/*
	基类 初始化App 配置fps
*/
import createjs from 'createjs-npm';
import store from '@/store/index';

export const App: any = {};
App.loader = null;
App.properties = {
  id: 'game',
  width: 1920,
  height: 1080,
  fps: 24,
  color: '#FFFFFF',
  opacity: 1.00,
  preloads: [],
};
export class Base {
    protected options: any;

    protected constructor(options: any) {
      this.options = options;
      this.init(options);
    }

    protected init(options: any) {
      this.load(options.resource);
    }

    protected startAnimation(stage: any) {
      createjs.Ticker.setFPS(App.properties.fps);
      createjs.Ticker.addEventListener('tick', stage);
      stage.enableMouseOver();
    }

    protected makeResponsive(isResp: any, respDim: any, isScale: any, scaleType: any, opts: any, stage: any) {
      let lastW: any;
      let lastH: any;
      let lastS: number = 1;
      const canvas: any = document.getElementById(opts.canvas);
      // const animContainer: any = document.getElementById(opts.container);
      // const domOverlayContainer: any = document.getElementById(opts.overlay);
      // resize
      (window as any).addEventListener('resize', resizeCanvas);
      resizeCanvas();
      function resizeCanvas(): void {
        const w: any = App.properties.width;
        const h: any = App.properties.height;
        const iw: any = window.innerWidth;
        const ih: any = window.innerHeight;
        const pRatio: any = window.devicePixelRatio || 1;
        const xRatio: any = iw / w;
        const yRatio: any = ih / h;
        let sRatio: any = 1;
        if (isResp) {
          if ((respDim === 'width' && lastW === iw) || (respDim === 'height' && lastH === ih)) {
            sRatio = lastS;
          } else if (!isScale) {
            if (iw < w || ih < h) {
              sRatio = Math.min(xRatio, yRatio);
            }
          } else if (scaleType === 1) {
            sRatio = Math.min(xRatio, yRatio);
          } else if (scaleType === 2) {
            sRatio = Math.max(xRatio, yRatio);
          }
        }
        canvas.width = w * pRatio * sRatio;
        canvas.height = h * pRatio * sRatio;
        // tslint:disable-next-line: whitespace
        canvas.style.width = `${w * sRatio}px`;
        canvas.style.height = `${h * sRatio}px`;
        stage.scaleX = pRatio * sRatio;
        stage.scaleY = pRatio * sRatio;
        lastW = iw; lastH = ih; lastS = sRatio;
        stage.tickOnUpdate = false;
        stage.update();
        stage.tickOnUpdate = true;
      }
    }

    protected initStage() {
    }

    protected initMask() {
      const mask = new createjs.Shape();
      mask.alpha = 0.5;
      mask.graphics.beginFill('#000000').drawRect(0, 0, 1920, 1080);
      return mask;
    }

    private load(resource: any) {
      App.loader = new createjs.LoadQueue(true);
      // 为App.loadered添加整个队列变化时展示的进度事件
      App.loader.addEventListener('progress', this.handleFileProgress);
      // 加载音频文件
      App.loader.installPlugin(createjs.Sound);
      // 为App.loadered添加当队列完成全部加载后触发事件
      App.loader.addEventListener('complete', this.loadComplete.bind(this));
      // 设置最大并发连接数  最大值为10
      App.loader.setMaxConnections(1);
      // 加载资源
      App.loader.loadManifest(resource);
    }

    // loading
    private handleFileProgress(event: any) {
      // console.log(Math.ceil(event.loaded * 100))
    }

    private loadComplete() {
      this.initStage();
      // for animate ready
      setTimeout(() => {
        store.commit('setGameLoading', false);
      }, 6000);
    }
}
